var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 27,
    viewBox: "0 0 7 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21716 25.9023C3.37337 26.0586 3.62663 26.0586 3.78284 25.9023L6.32843 23.3568C6.48464 23.2006 6.48464 22.9473 6.32843 22.7911C6.17222 22.6349 5.91895 22.6349 5.76274 22.7911L3.5 25.0538L1.23726 22.7911C1.08105 22.6349 0.827782 22.6349 0.671572 22.7911C0.515362 22.9473 0.515362 23.2006 0.671572 23.3568L3.21716 25.9023ZM3.5 0.619507L3.1 0.619507L3.1 25.6195L3.5 25.6195L3.9 25.6195L3.9 0.619507L3.5 0.619507Z",
    fill: "#A76352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBrown);
export default __webpack_public_path__ + "static/media/arrow-down-brown.ae7088fd8e568a643fd8966f1689f096.svg";
export { ForwardRef as ReactComponent };